import { SvgIcon } from '@mui/material'

const MoveInDate = props => (
  <SvgIcon
    viewBox="0 0 16 16"
    {...props}
    sx={{
      fill: 'none'
    }}
  >
    <path
      d="M5.33301 1.33331C5.7012 1.33331 5.99967 1.63179 5.99967 1.99998V2.66665H9.99967V1.99998C9.99967 1.63179 10.2982 1.33331 10.6663 1.33331C11.0345 1.33331 11.333 1.63179 11.333 1.99998V2.66665H13.9997C14.3679 2.66665 14.6663 2.96512 14.6663 3.33331V14C14.6663 14.3682 14.3679 14.6666 13.9997 14.6666H1.99967C1.63148 14.6666 1.33301 14.3682 1.33301 14V3.33331C1.33301 2.96512 1.63148 2.66665 1.99967 2.66665H4.66634V1.99998C4.66634 1.63179 4.96482 1.33331 5.33301 1.33331ZM9.99967 3.99998H5.99967V4.66665C5.99967 5.03484 5.7012 5.33331 5.33301 5.33331C4.96482 5.33331 4.66634 5.03484 4.66634 4.66665V3.99998H2.66634L2.66634 6.66665H13.333V3.99998H11.333V4.66665C11.333 5.03484 11.0345 5.33331 10.6663 5.33331C10.2982 5.33331 9.99967 5.03484 9.99967 4.66665V3.99998ZM2.66634 7.99998L2.66634 13.3333H13.333V7.99998H2.66634Z"
      fill="#050A22"
    />
  </SvgIcon>
)

export default MoveInDate
